import { buttons, buttonsRefresh } from './buttons';
import { colors, colorsRefresh } from './colors';
import { components, componentsRefresh } from './components';
import { cornerRadii, cornerRadiiRefresh } from './corner-radii';
import { popovers, popoversRefresh } from './popovers';
import { Responsive } from './responsive';
import { shadows, shadowsRefresh } from './shadows';
import { strokeWidths, strokeWidthsRefresh } from './stroke-widths';
import { text, textRefresh } from './text';
import { textButtons, textButtonsRefresh } from './textButtons';
import { Theme, ThemeName } from './Theme';
import gradients from './gradients';
import transitions from './transitions';
import units from './units';
export { Theme, ThemeName };
export var theme = new Theme(ThemeName.America, buttons, colors, components, cornerRadii, gradients, popovers, new Responsive(), shadows, strokeWidths, text, textButtons, transitions, units);
export function isRefresh(themeName) {
  return themeName === ThemeName.Refresh;
}
export var themeRefresh = new Theme(ThemeName.Refresh, buttonsRefresh, colorsRefresh, componentsRefresh, cornerRadiiRefresh, gradients, popoversRefresh, new Responsive(), shadowsRefresh, strokeWidthsRefresh, textRefresh, textButtonsRefresh, transitions, units);
export function getThemeByName(themeName) {
  if (isRefresh(themeName)) {
    return themeRefresh;
  }

  return theme;
}
export default theme;